import { useEffect } from 'react';

import { type TModePathInput, useSpotlightAPI } from '@frontend/components/Spotlight/store';

/**
 * Set the Spotlight's default mode (the path every close resets to) while the
 * calling component is mounted, restoring the prior default on unmount. Accepts a
 * path string or a segments array. Pass a stable reference — a new identity
 * re-applies.
 */
export function useSpotlightDefaultMode(input: TModePathInput): void {
  const api = useSpotlightAPI();
  useEffect(() => api.setDefaultMode(input), [api, input]);
}
